import React from 'react';
import ecocareLogo from '../../assets/images/ecocare-logo.svg';
import classes from './VideoConsultingRoom.module.scss';
import { useTranslation } from '../../hooks/useTranslations';

export default function EmptyScreen({
  fullName,
  style,
}: {
  fullName: string;
  style?: React.CSSProperties;
}) {
  const { translations } = useTranslation();

  return (
    <div className={classes.videoEndContainer} style={{ ...style }}>
      <img src={ecocareLogo} alt="ecocareLogo" />
      <div className={classes.callInfoContainer}>
        <div className={classes.callInfoLabel}>{translations('video.call with')}</div>
        <div className={classes.patientFullName}>{fullName}</div>
        <div className={classes.callInfoLabel}>{translations('has.ended')}</div>
      </div>
    </div>
  );
}
